import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../../contexts/AdminAuthContext';
import { apiAdminLogin } from '../../../api/adminApi';
import '../admin.css';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { adminLogin, isAdminLoggedIn } = useAdminAuth();
  const [email,   setEmail]   = useState('');
  const [pw,      setPw]      = useState('');
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAdminLoggedIn) navigate('/admin/dashboard', { replace: true });
  }, [isAdminLoggedIn, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !pw.trim() || loading) return;
    setLoading(true);
    setError('');
    try {
      const data = await apiAdminLogin(email.trim(), pw);
      if (!data.isAdmin) {
        setError('어드민 권한이 없는 계정입니다.');
        return;
      }
      adminLogin();
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) {
        setError('이메일 또는 비밀번호가 올바르지 않습니다.');
      } else if (status === 403) {
        setError('어드민 권한이 없는 계정입니다.');
      } else {
        setError('로그인에 실패했습니다. 다시 시도해주세요.');
      }
    } finally {
      setLoading(false);
    }
  };

  const active = email.trim() && pw.trim();

  return (
    <div className="admin-root ag-login-wrap">
      <div className="ag-login-box">
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <i className="ti ti-movie" style={{ fontSize: 20 }} />
            <span className="ag-login-title">CastarAdmin</span>
          </div>
          <div className="ag-login-sub">어드민 관리 시스템 — 권한자만 접근 가능합니다.</div>
        </div>

        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className="ag-field">
            <label className="ag-field__label">이메일</label>
            <input
              className="ag-field__input"
              type="text"
              placeholder="admin ID"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
            />
          </div>
          <div className="ag-field" style={{ marginBottom: 0 }}>
            <label className="ag-field__label">비밀번호</label>
            <input
              className="ag-field__input"
              type="password"
              placeholder="password"
              value={pw}
              onChange={e => setPw(e.target.value)}
            />
          </div>

          {error && (
            <div style={{ fontSize: 12, color: 'var(--color-danger)' }}>{error}</div>
          )}

          <button
            type="submit"
            disabled={!active || loading}
            className={`ag-btn${active && !loading ? ' ag-btn--primary' : ''}`}
            style={{ width: '100%', justifyContent: 'center', padding: '10px', marginTop: 4 }}
          >
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
      </div>
    </div>
  );
}
